// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"aeb42eab","614":"173d33b8","741":"173d33b8","877":"173d33b8"}[chunkId] + ".chunk.css";
};